import { Button } from "@mui/material";
import { PromoTagIcon } from "../Icons";
import React from "react";

type IPromoCodeProps = {
    promoCode: {
      _id: string;
      promoCode: string;
      description: string;
    };
    handleRemoveCode: (id: string) => void;
}

type IPromoCodeUsedProps = {
    promoCodeUsed: string;
}

const PromoCode = (props: IPromoCodeProps) => {
  const { handleRemoveCode, promoCode } = props;

  const handleDeletePromoCode = (id: string) => {
    handleRemoveCode(id);
  };

  return (
    <div className="w-full flex rounded-lg self-stretch items-center border border-taupe-50 bg-white p-3 gap-2">
      <div className="promo-turquoise flex flex-col gap-1 grow">
        <div className="flex gap-[6px] items-center">
          <PromoTagIcon/>
          <p className="text-promo-turquoise font-semibold leading-6 text-sm">{promoCode.promoCode}</p>
        </div>
        <p className="font-semibold text-black leading-6 text-sm">{promoCode.description}</p>
      </div>
      <Button variant="contained" size="small" onClick={()=>handleDeletePromoCode(promoCode._id)} sx=
        {{ fontSize: "12px", background: "transparent", borderColor: "#DAD7D6" }}>
                    Remove</Button>
    </div>
  );
};

export const PromoCodeUsed = (props: IPromoCodeUsedProps) => {
  const { promoCodeUsed } = props;

  return (
    <div className="flex gap-4 rounded items-center">
      <PromoTagIcon color="#262626" height={24} width={24}/>
      <p className="font-semibold text-black leading-6 text-sm w-5/6">{promoCodeUsed}</p>
    </div>
  );
};

export default PromoCode;
